import { takeLatest, call, put, select } from 'redux-saga/effects';
import _ from 'lodash';
import axios from '../axiosConfig';
import { getFlightSeatmapRequest, getFlightSeatmapSuccess } from '../../slices/flight';

const queryString = require('query-string');

function* getFlightSeatMapWorker({ payload: { flight, orderId, key } }) {
  try {
    const currencyCode = flight && flight.selectedFare && flight.selectedFare.currencyCode;
    const url = '/flights/seatmap';
    const { staterooms } = yield select((store) => store.tripSearch.searchObj);
    const { isLoggedIn, travelAgency } = yield select((store) => store.user);

    const requestObj = {};
    if (currencyCode) requestObj.currencyCode = currencyCode;
    if (!isLoggedIn && travelAgency) {
      requestObj.agencyAliasName = travelAgency.agencyAliasName;
    }
    const config = {
      method: 'post',
      url: `${url}?${queryString.stringify(requestObj, { skipNull: true })}`,
      data: JSON.stringify({
        flight,
        adults: _.sumBy(staterooms, (st) => st.adults || 0),
        seniors: _.sumBy(staterooms, (st) => st.seniors || 0),
        lapInfants: _.sumBy(staterooms, (st) => st.lapInfants || 0),
        seatInfants: _.sumBy(staterooms, (st) => st.seatInfants || 0),
        children: _.flatMap(staterooms, (st) => Object.values(st.children || [])),
        orderId: orderId,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const { data } = yield call(axios, config);
    yield put(
      getFlightSeatmapSuccess({
        responseData: data,
        key,
      }),
    );
  } catch (error) {
    let errorText = 'Error with your request, please try again later.';
    if (error && error.response) {
      errorText = `${error.response.data.title} ${error.response.data.detail}`;
    }
    yield put(
      getFlightSeatmapSuccess({
        error: errorText,
        responseData: {},
        key,
      }),
    );
  }
}

function* getTripWatcher() {
  yield takeLatest(getFlightSeatmapRequest.toString(), getFlightSeatMapWorker);
}

export default getTripWatcher;
